import { render, staticRenderFns } from "./QuestionnaireS2.vue?vue&type=template&id=c22c49d4&"
import script from "./QuestionnaireS2.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireS2.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireS2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports